// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 11 !important;
  background-color: #fff;
  transform: translateY(100vh);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/compat/ion-bottom-drawer/ion-bottom-drawer.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;AACF","sourcesContent":[":host {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  z-index: 11 !important;\n  background-color: #fff;\n  transform: translateY(100vh);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
